import React, { useEffect, useState } from "react";
import classes from "./PersonDetails.module.css";
import BlackHeader from "../Components/Header/BlackHeader";
import { useNavigate, useParams } from "react-router-dom";
import { useFetchPersonDetailsMutation } from "../Slices/httpSlice";
import { toast } from "react-toastify";
import { motion, useAnimationControls } from "framer-motion";
import MediaDetailsLoading from "../Components/MediaDetails/MediaDetailsLoading";
import MovieCard from "../Components/Drag-Cards/MovieCard";

const PersonDetails = () => {
  const navigate = useNavigate();
  const { personId, personName } = useParams();
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [personDetailsApi, { isLoading }] = useFetchPersonDetailsMutation();

  const [modal, setModal] = useState<boolean>(false);

  const fetchData = async () => {
    setLoading(true);
    const response: any = await personDetailsApi({
      body: {
        id: personId,
        person: personName,
      },
    });
    setLoading(false);
    if (response?.error) {
      console.log(response.error, "error");
      toast.error(
        response?.error?.data?.error?.error ||
          response?.error?.data?.error ||
          response?.error?.data ||
          response?.error?.message ||
          "Something Went Wrong!"
      );
    } else {
      setData(response?.data?.result);
    }
  };

  useEffect(() => {
    fetchData();
  }, [personId, personName]);

  const variants = {
    hidden: {
      y: window.innerHeight * 0.7,
      display: "none",
    },
    visible: {
      y: 0,
      display: "block",
    },
  };

  const controls = useAnimationControls();

  useEffect(() => {
    if (modal) {
      controls.start("visible");
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [modal]);

  const closeModal = () => {
    controls.start("hidden");
    setModal(false);
  };

  console.log(data, "d");
  return (
    <>
      {loading ? (
        <MediaDetailsLoading />
      ) : (
        <>
          <div
            className={classes.section_person}
            style={{
              overflowY: modal ? "hidden" : "auto",
              cursor: modal ? "pointer" : "default",
            }}
            onClick={() => closeModal()}
          >
            <div className={`${classes.background_wrapper}`}>
              <div className={`${classes.wrapper}`}>
                <div className={classes.navbar}>
                  <button
                    className={classes.close_btn}
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    <i className={`pi pi-arrow-left ${classes.close_icon}`} />
                  </button>
                </div>

                <div className={classes.info_container}>
                  <div className={classes.main_card}>
                    <div className={classes.main_card_image}>
                      <img
                        src={`${process.env.REACT_APP_MEDIA_PATH_PREFIX?.replace(
                          "<replace_media_id>",
                          data?.personDetails?.profile_path
                        )}`}
                        alt="movie"
                        className={classes.main_card_img}
                      />
                    </div>
                    <div className={classes.main_card_content}>
                      <p className={classes.main_card_title}>
                        {data?.personDetails.name ??
                          data?.personDetails.original_name}
                      </p>
                    </div>
                  </div>

                  {/* <p className={classes.info}></p> */}
                  <p className={classes.info_brief}>
                    {/* {data?.personDetails2?.biography.slice(0,300)} */}
                    {data?.personDetails2?.biography &&
                      (data.personDetails2.biography.length <= 300 ? (
                        data.personDetails2.biography
                      ) : (
                        <>
                          {data.personDetails2.biography.slice(0, 300)}
                          <span>... </span>
                          <span
                            style={{
                              color: "rgb(245,197,24)",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setModal((prevValue) => !prevValue);
                            }}
                          >
                            Read more
                          </span>
                        </>
                      ))}
                  </p>
                </div>
              </div>
            </div>

            <div className={classes.section_main}>
              <div className={classes.header}>
                <p className={classes.header_title}>Known For</p>
              </div>

              <motion.div
                className={classes.section_card}
                style={{
                  gridTemplateColumns: `repeat(${data?.personDetails?.known_for?.length}, 150px)`,
                }}
                drag="x"
                dragConstraints={{
                  top: 0,
                  left: -(window.innerWidth <= 800
                    ? 10 +
                      data?.personDetails?.known_for?.length * 150 +
                      data?.personDetails?.known_for?.length * 10 +
                      data?.personDetails?.known_for?.length * 1 -
                      window.innerWidth
                    : window.innerWidth * 0.05 +
                      data?.personDetails?.known_for?.length * 150 +
                      data?.personDetails?.known_for?.length * 10 +
                      data?.personDetails?.known_for?.length * 1 -
                      window.innerWidth),
                  right: 0,
                  bottom: 0,
                }}
                transition={{
                  type: "spring",
                  damping: 100,
                  stiffness: 100,
                }}
              >
                {data?.personDetails?.known_for?.length > 0 &&
                  data?.personDetails?.known_for.map(
                    (dataItem: any, idx: number) => {
                      return (
                        <MovieCard
                          key={idx}
                          data={dataItem}
                          navigateTo={
                            dataItem?.media_type == "movie"
                              ? "movies"
                              : "series"
                          }
                        />
                      );
                    }
                  )}
              </motion.div>

              <div className={classes.header}>
                <p className={classes.header_title}>Credits</p>
              </div>

              <motion.div
                className={classes.section_card}
                style={{
                  gridTemplateColumns: `repeat(${data?.data?.length}, 150px)`,
                }}
                drag="x"
                dragConstraints={{
                  top: 0,
                  left: -(window.innerWidth <= 800
                    ? 10 +
                      data?.data?.length * 150 +
                      data?.data?.length * 10 +
                      data?.data?.length * 1 -
                      window.innerWidth
                    : window.innerWidth * 0.05 +
                      data?.data?.length * 150 +
                      data?.data?.length * 10 +
                      data?.data?.length * 1 -
                      window.innerWidth),
                  right: 0,
                  bottom: 0,
                }}
                transition={{
                  type: "spring",
                  damping: 100,
                  stiffness: 100,
                }}
              >
                {data?.data?.length > 0 &&
                  data?.data.map((dataItem: any, idx: number) => {
                    return (
                      <MovieCard
                        key={idx}
                        data={dataItem}
                        navigateTo={
                          dataItem?.media_type == "movie" ? "movies" : "series"
                        }
                      />
                    );
                  })}
              </motion.div>
            </div>
          </div>

          <motion.div
            className={classes.modal}
            variants={variants}
            initial="hidden"
            animate={controls}
            transition={{
              duration: 0.1,
              type: "spring",
              //   damping: 10,
              damping: 20,
              stiffness: 100,
            }}
          >
            <div className={classes.modal_nav}>
              <button
                className={classes.close_btn}
                type="button"
                onClick={() => closeModal()}
              >
                <i className={`pi pi-times ${classes.close_icon}`} />
              </button>
            </div>

            <p className={classes.bio_title}>
              {data?.personDetails2?.name ??
                data?.personDetails2?.original_name}
            </p>
            <p className={classes.bio}>{data?.personDetails2?.biography}</p>
          </motion.div>
        </>
      )}
    </>
  );
};

export default PersonDetails;
